// Core
import { useState } from 'react';
import VerificationInput from 'react-verification-input';
import { 
  Button,
  Flex, 
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
  useBreakpointValue,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

const CodeModal = ({
	handle,
	seconds, 
  startTimer, 
  timerActive, 
  isValidCode, 
  setIsValidCode,
	onOpen, 
	isOpen, 
	onClose, 
	errorCard,
	title, 
	description,
	type = 'change'
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const textColor = useColorModeValue('#262D47', '#9FABCB');

	const { colorMode } = useColorMode();
	const isDark = colorMode === 'dark';

	const handleCode = value => { 
	    if(value?.length === 6){
	    	handle(value);
	    } 

	    setIsValidCode(true);
	};

	const isMobile = useBreakpointValue({ base: true, md: false });

    return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple modal_code" 
              maxW={{ sm: '620px' }} 
              style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
          <ModalCloseButton style={{zIndex: '9'}} />
              { isDark && <Box bg="rgba(64, 155, 255, 0.82)" filter="blur(70px)" w="90%" h="150px"
                  transform="translate(-50%, 0px)" left="50%" 
                  top="-200px" position="absolute" borderRadius="full" /> }

              <Box position="relative" p="0 8px 0 8px" textAlign="center">
                  <Text 
                      variant="title-lg"
                      zIndex="3" 
                      pt="24px"
                      fontSize="32px"
                      fontStyle="italic"
                      fontWeight="700"
                      position="relative">{ title }</Text>

                  <Text mt="16px" fontStyle="italic" p={{base: '0', md: '0 40px'}}>
                      { description }
                  </Text>

                  <VerificationInput
	                length={6}
	                placeholder=""
	                validChars="0-9"
	                classNames={{
	                  container: `code-container ${isMobile ? 'code-container-mobile' : ''} ${isValidCode ? 'input-valid-code' : 'input-invalid-code'}`,
	                  character: `code-character ${isLoading ? 'input-freeze-code' : ''}`,
	                  characterInactive: 'character--inactive',
	                  characterSelected: 'character--selected',
	                }}
	                onChange={handleCode}
	              />

	              {!isLoading && (
	                <>
	                  
	                  <Flex justify="center" mt="21px" gap="8px">
	                  	<Text color={textColor} className={!timerActive ? 'hidden' : ''}>
		                  	Wait for 
		                  	<Text as="span" pl="4px" color={textColor}>
		                    	{Math.floor(seconds / 60)}:{seconds % 60 < 10 ? `0${seconds % 60}` : seconds % 60}
		                    </Text>
		                </Text>
	                    <Text 
	                    	color={ timerActive ? textColor : '#099BFF'}
	                    	variant="title-md" 
	                    	cursor="pointer"
	                    	pointerEvents={ timerActive ? 'none' : 'unset'}
	                    	onClick={handle}>
	                    	Send Again
	                    </Text>
	                  </Flex>
	                </>
	              )}

                  <Flex  mt="40px" gap="12px">
                    <Button variant="secondary-md" onClick={() => { onClose(); }}>Cancel</Button>
                    <Button variant="button-md" onClick={() => { handleCode(); onClose(); }}>{ type === 'change' ? 'Change' : 'Сontinue'}</Button>
                  </Flex>
              </Box>
          </ModalContent>
        </Modal> 
      </>
  );
};

export default CodeModal;